module.exports = __webpack_public_path__ + "img/08.9dd2bd70.jpg";